import { _ as _slicedToArray } from '../slicedToArray-DvtHmgP0.js';
import { useState, useCallback } from 'react';

var useForceUpdate = function useForceUpdate() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    update = _useState2[1];
  return useCallback(function () {
    return update({});
  }, []);
};

export { useForceUpdate as default };
//# sourceMappingURL=index.js.map
